import styled from 'styled-components'

import zIndex from '../../utils/zIndexScale'

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.exchangeMainBg};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  @media (min-width: 20px) and (max-width: 768px) {
    position: relative;
  }
`

export const Content = styled.div`
  position: absolute;
  width: 100%;
  top: 60px;
  display: flex;
  bottom: 260px;
  min-height: 340px;
  justify-content: space-between;
  @media (min-width: 20px) and (max-width: 768px) {
    position: relative;
    top: 44px;
    display: block;
    min-width: 320px;
  }
`

export const ContentLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 290px;
  margin-right: 10px;
  @media (min-width: 20px) and (max-width: 1000px) {
    display: none;
  }
`

export const ContentCenter = styled.div`
  position: absolute;
  left: 300px;
  right: 300px;
  height: 100%;
  background: ${({ theme }) => theme.exchangeSecondBg};
  @media (min-width: 20px) and (max-width: 1000px) {
    position: relative;
    left: 0;
    width: 100%;
    height: auto;
  }
`

export const ContentRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 290px;
  background: #131722;
  @media (min-width: 20px) and (max-width: 1000px) {
    display: none;
  }
`

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 250px;
  z-index: ${zIndex.footer};
  min-width: 500px;
  @media (max-width: 768px) {
    position: relative;
    top: 54px;
  }
`

export const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  padding: 20px 0;
`

export const ButtonTabs = styled.div`
  margin-top: 10px;
  font-size: 16px;
  background: #12161c;
  padding: 0 12px;
  z-index: ${zIndex.fixedTab};
  min-width: 320px;
  position: relative;
  border-bottom: 1px solid #000;
  height: 35px;
  line-height: 35px;
  display: none;
  .tab {
    color: #fff;
    width: 50px;
    text-align: left;
    transition: all 0.2s ease-in;
    margin-right: 30px;
    user-select: none;
  }

  .tab.on {
    color: #f0b90b;
    font-weight: 600;
  }

  .tab-scrollbar {
    position: absolute;
    bottom: 1px;
    left: 10px;
    background: #f0b90b;
    height: 2px;
    width: 50px;
    transition: all 200ms ease-in-out;
  }

  .tab:nth-of-type(1).on ~ .tab-scrollbar {
    transform: translate3d(0, 0, 0);
  }

  .tab:nth-of-type(2).on ~ .tab-scrollbar {
    transform: translate3d(75px, 0, 0);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`

export const TabContent = styled.div`
  display: none;
  position: relative;
  width: 100%;
  flex-direction: column;
  min-width: 320px;
  background: ${({ theme }) => theme.exchangeSecondBg};
  @media (max-width: 768px) {
    display: ${({ show }) => (show ? 'block' : 'none')};
  }
`

export const ChartContent = styled(TabContent)`
  display: block;
  position: absolute;
  top: 65px;
  bottom: 0;
  left: 0;
  right: 0;
  @media (max-width: 768px) {
    height: 350px;
    position: relative;
    top: 0;
    z-index: ${zIndex.normalZIndex};
  }
`
